/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-var */
/* eslint-disable import/prefer-default-export */
/* eslint-disable no-undef */
import Web3 from 'web3';
import axios from 'axios';
import { ENVIRONMENT } from 'configs';
import NFTContract from 'configs/abis/NFTMarketplace.json';

var web3 = new Web3(
  Web3.givenProvider || 'ws://some.local-or-remote.node:8546'
);
//
export const getAllNFTs = async () => {
  const contract = new web3.eth.Contract(
    NFTContract.abi,
    ENVIRONMENT.CONTRACT_ADDRESS
  );
  const items = await contract.methods.fetchMarketItems().call();
  const allItems = await Promise.all(
    items.map(async (i) => {
      const tokenUri = await contract.methods.tokenURI(i.tokenId).call();
      const item = await axios.get(`https://ipfs.io/ipfs/${tokenUri}`);
      return {
        token_id: i.tokenId,
        name: item.data.name,
        description: item.data.description,
        external: item.data.external,
        image: item.data.image,
        price: i.price,
        sold: i.sold,
        seller: i.seller,
        currentOwner: i.holder,
      };
    })
  );
  return allItems;
};

export const checkConnectivity = async () => {
  if (!window.ethereum) return alert('Please install MetaMask.');
  const account = await web3.eth.getAccounts();
  const chainId = await web3.eth.getChainId();
  console.log(chainId, 'ChainId');
  if (account[0]) {
    return { account: account[0], connected: true, chainId };
  }
  return { account: null, connected: false, chainId };
};
